// extracted by mini-css-extract-plugin
export default {"input_wrapper":"Review_input_wrapper__qTTUd","checkboxAgree":"Review_checkboxAgree__5cEqL","SectionTitle":"Review_SectionTitle__OnGta"};